<template>
    <v-container fluid>
        <!-- Tabella -->
        <v-data-table
            v-if="data_table === true"
            :headers="headers.filter((c) => c.visible != false)"
            fixed-header
            :items="servizi.filter((c) => c.validita == true)"
            :items-per-page="items_per_page"
            :page="page_num"
            @update:page="pageChange"
            item-key="id_servizio"
            class="elevation-1"
            calculate-widths
            height="74vh"
            :key="data_table_key"
        >
            <template v-slot:[`item.select`]="{ item }">
                <v-checkbox v-model="item.selected" />
            </template>

            <template v-slot:[`item.des_stato`]="{ item }">
                <v-row>
                    <v-col cols="2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    class="pt-4"
                                    v-bind="attrs"
                                    v-on="on"
                                    :color="
                                        item.des_stato == 'Concluso'
                                            ? 'success'
                                            : item.des_stato == 'Aperto'
                                            ? 'warning'
                                            : 'error'
                                    "
                                >
                                    {{ item.icona_stato }}
                                </v-icon>
                            </template>
                            <span>{{ item.des_stato }}</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="10">
                        <v-select
                            class="pt-3"
                            :items="items_stato"
                            v-model="item.des_stato"
                            item-text="des"
                            dense
                            label="Stato"
                            @change="changeState(item)"
                        />
                    </v-col>
                </v-row>
            </template>

            <!-- Intestazione tabella -->
            <template v-slot:top>
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        Servizi
                        <v-icon color="white"> mdi-face-agent </v-icon>
                    </v-toolbar-title>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="ApriAnagrafica"
                                class="ml-5"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="primary"> mdi-factory </v-icon>
                            </v-btn>
                        </template>
                        <span>Gestione aziende</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="allReport"
                                class="ml-auto"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="primary">
                                    mdi-file-document-multiple-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Report Servizi</span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_gestione_aziende2 = true"
                class="ml-5"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="purple"> mdi-factory </v-icon>
              </v-btn>
            </template>
            <span>Gestione aziende</span>
          </v-tooltip> -->

                    <!-- <v-btn @click="dialog_extra = true" class="ml-5" small>
            <v-icon color="primary"> mdi-archive </v-icon>
          </v-btn> -->

                    <!-- Pulsante che nasconde la tabella e visualizza il template di creazione servizio -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="nuovoServizio()"
                                class="ml-5"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="primary"> mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Nuovo Servizio</span>
                    </v-tooltip>

                    <!-- Pulsante per la seleziona multipla. -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="is_selez_multipla = !is_selez_multipla"
                                class="ml-5"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon
                                    :color="
                                        is_selez_multipla ? 'error' : 'primary'
                                    "
                                >
                                    {{
                                        is_selez_multipla
                                            ? "mdi-playlist-remove"
                                            : "mdi-playlist-check"
                                    }}
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{
                                is_selez_multipla
                                    ? "Nascondi selezione multipla"
                                    : "Visualizza selezione multipla"
                            }}</span
                        >
                    </v-tooltip>

                    <!-- Visualizza/nascondi filtri -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-auto mr-5"
                                v-bind="attrs"
                                v-on="on"
                                small
                                @click="
                                    filters == true
                                        ? (filters = false)
                                        : (filters = true)
                                "
                            >
                                <v-icon color="purple"> mdi-filter </v-icon>
                            </v-btn>
                        </template>
                        <span v-if="filters == false">Visualizza Filtri</span>
                        <span v-else>Nascondi Filtri</span>
                    </v-tooltip>
                    <!-- Pulsante torna indietro -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="goBack()"
                                class="ml-15"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="error">
                                    mdi-keyboard-backspace
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Vai alla Dashboard</span>
                    </v-tooltip>
                </v-toolbar>

                <v-card
                    class="mb-2"
                    v-show="is_selez_multipla"
                    height="40px"
                    color="#FFEEEE"
                >
                    <!-- Pulsante per selezionare tutta la pagina. -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="selezionaServiziPagina()"
                                class="ml-5 mt-1"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="primary">
                                    mdi-order-bool-descending-variant
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Seleziona pagina</span>
                    </v-tooltip>

                    <!-- Pulsante per ripianificazione multipla servizi. -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="ripianifica_dialog = true"
                                class="ml-5 mt-1"
                                v-bind="attrs"
                                v-on="on"
                                small
                                :disabled="
                                    servizi.filter((c) => c.selected == true)
                                        .length == 0
                                "
                            >
                                <v-icon color="primary">
                                    mdi-cog-counterclockwise</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Ripianifica selezionati</span>
                    </v-tooltip>

                    <!-- Pulsante per eliminazione multipla servizi. -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="delete_dialog = true"
                                class="ml-5 mt-1"
                                v-bind="attrs"
                                v-on="on"
                                small
                                :disabled="
                                    servizi.filter((c) => c.selected == true)
                                        .length == 0
                                "
                            >
                                <v-icon color="error"> mdi-trash-can</v-icon>
                            </v-btn>
                        </template>
                        <span>Elimina selezionati</span>
                    </v-tooltip>
                </v-card>

                <!-- Row Filtri -->
                <v-row v-if="filters === true" justify="center" class="ma-1">
                    <v-col cols="4" md="3">
                        <v-autocomplete
                            @change="filtra"
                            label="Ragione sociale"
                            v-model.number="azienda_filter"
                            dense
                            hide-details
                            :items="items_azienda"
                            class="mt-5"
                            item-text="ragione_sociale"
                            item-value="id_anagrafica"
                        />
                    </v-col>
                    <v-col cols="4" md="3">
                        <v-text-field
                            @change="filtra"
                            label="Codice"
                            v-model="codice_filter"
                            dense
                            hide-details
                            class="mt-5"
                        />
                    </v-col>
                    <v-col cols="4" md="3">
                        <v-text-field
                            @change="filtra"
                            label="Comune partenza"
                            v-model="localita_partenza_filter"
                            dense
                            hide-details
                            class="mt-5"
                        />
                    </v-col>
                    <v-col cols="4" md="3">
                        <v-text-field
                            @change="filtra"
                            label="Comune destinazione"
                            v-model="localita_arrivo_filter"
                            dense
                            hide-details
                            class="mt-5"
                        />
                    </v-col>
                    <v-col cols="4" md="3">
                        <v-text-field
                            @change="filtra"
                            label="Note"
                            v-model="descrizione_filter"
                            dense
                            hide-details
                            class="mt-5"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-menu
                            v-model="data_inizio_menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            min-width="289"
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    background-color="#ffffff"
                                    hide-details
                                    label="Data Inizio Servizio"
                                    :value="formatData(data_inizio_filter)"
                                    v-on="on"
                                >
                                </v-text-field>
                            </template>
                            <v-date-picker
                                first-day-of-week="1"
                                v-model="data_inizio_filter"
                                @input="data_inizio_menu = false"
                            />
                        </v-menu>
                    </v-col>
                    <v-col cols="3">
                        <v-menu
                            v-model="data_fine_menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            min-width="289"
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    background-color="#ffffff"
                                    hide-details
                                    label="Data Fine Servizio"
                                    :value="formatData(data_fine_filter)"
                                    readonly
                                    v-on="on"
                                />
                            </template>
                            <v-date-picker
                                first-day-of-week="1"
                                v-model="data_fine_filter"
                                @input="data_fine_menu = false"
                            />
                        </v-menu>
                    </v-col>
                    <v-col cols="1">
                        <!-- Reset filtri -->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="mt-5"
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    @click="resetFiltri"
                                >
                                    <v-icon color="error">
                                        mdi-filter-off
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Resetta Filtri</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="1">
                        <!-- Pulsante filtra -->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="filtra"
                                    class="mt-4 success"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon> mdi-magnify </v-icon>
                                </v-btn>
                            </template>
                            <span>Filtra</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </template>
            <!-- Pulsante Modifica -->
            <template v-slot:[`item.edit`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            @click="
                                tab = 1;
                                carica_dettaglio = false;
                                selectItem(item);
                                data_table = false;
                            "
                        >
                            <v-icon color="primary">mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Dettagli</span>
                </v-tooltip>
            </template>
            <!-- Pulsante Report -->
            <template v-slot:[`item.report`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            @click="getReport(item)"
                        >
                            <v-icon color="primary"
                                >mdi-file-document-outline</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Report</span>
                </v-tooltip>
            </template>
            <!-- TAG Pianificazione -->
            <template v-slot:[`item.pianificato`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-if="item.pianificato >= 0"
                            v-bind="attrs"
                            v-on="on"
                            @click="clickIconPianificazione(item)"
                            :color="
                                item.id_servizio_successivo != 0 ||
                                item.id_servizio_precedente != 0
                                    ? 'primary'
                                    : item.pianificato === 1
                                    ? 'success'
                                    : 'warning'
                            "
                        >
                            mdi-order-bool-ascending
                        </v-icon>
                        <v-icon
                            v-if="item.pianificato < 0"
                            v-bind="attrs"
                            v-on="on"
                            color="error"
                        >
                            {{
                                item.pianificato == -1
                                    ? "mdi-engine"
                                    : item.pianificato == -2
                                    ? "mdi-truck-cargo-container"
                                    : "mdi-card-account-details"
                            }}
                        </v-icon>
                    </template>
                    <span v-if="item.pianificato === 1"
                        >Pianificazione riuscita</span
                    >
                    <span v-if="item.pianificato === 0"
                        >Pianificazione non eseguita</span
                    >
                    <span v-if="item.pianificato === -1"
                        >Non ci sono motrici idonee</span
                    >
                    <span v-if="item.pianificato === -2"
                        >Non ci sono cassoni idonei</span
                    >
                    <span v-if="item.pianificato === -3"
                        >Non ci sono conduttori idonei</span
                    >
                    <span v-if="item.pianificato === -5"
                        >Non ci sono slot calendario disponibili</span
                    >
                    <span v-if="item.pianificato === -6"
                        >Non ci sono slot calendario disponibili per l'orario
                        specifico richiesto</span
                    >
                    <span v-if="item.pianificato === -7"
                        >L'orario attuale è successivo al termine della fascia
                        oraria richiesta</span
                    >
                </v-tooltip>
            </template>
            <!-- TAG GOOGLE -->
            <template v-slot:[`item.google`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            :color="
                                item.distanza != null &&
                                item.tempo_percorrenza != null
                                    ? 'success'
                                    : 'warning'
                            "
                            >mdi-google-maps</v-icon
                        >
                    </template>
                    <span
                        v-if="
                            item.distanza != null &&
                            item.tempo_percorrenza != null
                        "
                        >Calcolo del percorso riuscito</span
                    >
                    <span v-else>Calcolo del percorso fallito</span>
                </v-tooltip>
            </template>
            <!-- Azienda -->
            <template v-slot:[`item.id_azienda`]="{ item }">
                {{
                    tot_servizi.filter((t) => t.id_azienda == item.id_azienda)
                        .length > 0
                        ? tot_servizi.filter(
                              (t) => t.id_azienda == item.id_azienda
                          )[0].des_azienda
                        : "N/D"
                }}
            </template>

            <!-- Data inizio -->
            <template v-slot:[`item.data_inizio`]="{ item }">
                <span v-if="item.data_inizio != null">{{
                    formatData(item.data_inizio)
                }}</span>
            </template>
            <template v-slot:[`item.inizio_attivita`]="{ item }">
                <span v-if="item.inizio_attivita != null">{{
                    item.inizio_attivita
                }}</span>
            </template>
            <!-- Data fine -->
            <template v-slot:[`item.data_fine`]="{ item }">
                <span v-if="item.data_fine != null">{{
                    formatData(item.data_fine)
                }}</span>
                <!-- <span v-else></span> -->
            </template>
            <!-- Pulsante dialog eliminazione -->
            <template v-slot:[`item.delete`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            @click="
                                selectItem(item);
                                delete_dialog = true;
                            "
                        >
                            <v-icon color="error">mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Elimina</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <!-- Create/Edit template -->
        <template v-if="data_table === false">
            <v-card min-height="70vh">
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        Servizi
                        <v-icon color="white"> mdi-face-agent </v-icon>
                    </v-toolbar-title>
                    <v-spacer />
                    <!-- Gestione aziende non utilizzato da Elsa -->
                    <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="ApriAnagrafica"
                class="ml-auto"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary"> mdi-factory </v-icon>
              </v-btn>
            </template>
<span>Gestione aziende</span>
</v-tooltip> -->
                    <!-- Salva Servizio senza pianificazione -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-5"
                                @click="OpenGraph()"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="primary"> mdi-chart-bar </v-icon>
                            </v-btn>
                        </template>
                        <span>QuickGraph</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                :disabled="
                                    selected_item.indirizzo_arrivo == '' ||
                                    selected_item.indirizzo_partenza == ''
                                "
                                class="ml-5"
                                v-bind="attrs"
                                v-on="on"
                                small
                                @click="openServiziSuggeriti"
                            >
                                <v-icon color="primary">
                                    mdi-map-marker-path
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Associa servizio</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-5"
                                @click="salvaServizio()"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva modifiche</span>
                    </v-tooltip>
                    <!-- Salva e pianifica -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-5"
                                @click="
                                    if (selected_item.pianificato == 0)
                                        salvaPianificazione();
                                    else salvaServizio(true);
                                "
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="success">
                                    mdi-order-bool-ascending
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva e pianifica</span>
                    </v-tooltip>
                    <!-- Allinea anagrafiche non utilizzato da Elsa -->
                    <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5"
                @click="getAllineaAnagrafiche()"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary"> mdi-sync </v-icon>
              </v-btn>
            </template>
            <span>Allinea anagrafiche</span>
          </v-tooltip> -->
                    <!-- Allinea anagrafiche -->

                    <v-spacer />
                    <!-- Pulsante annulla modifiche -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-auto"
                                @click="resetTab()"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="error">
                                    mdi-keyboard-backspace
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Indietro</span>
                    </v-tooltip>
                </v-toolbar>

                <!------- Tabs ------->
                <v-tabs v-model="tab" align-with-title>
                    <v-tabs-slider color="transparent"></v-tabs-slider>
                    <v-tab active-class="sfondoStandard" class="py-0 my-0">
                        Generale
                    </v-tab>
                    <v-tab active-class="sfondoStandard" class="py-0 my-0">
                        Opzioni
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <QLGenerale
                            @aggiornaTipoPagamento="
                                aggiornaTipoPagamentoOpzioni
                            "
                            ref="createEdit"
                            :selected_item="selected_item"
                        />
                        <!--:items_azienda="items_azienda"-->
                    </v-tab-item>
                    <v-tab-item>
                        <QLOpzioni
                            ref="createDettaglio"
                            @GetDettagliServizio="
                                getDettagliServizio();
                                getServizi();
                            "
                            @dettaglio_caricato="
                                tab = !carica_dettaglio ? 0 : tab;
                                carica_dettaglio = true;
                            "
                            :servizio="selected_item"
                            :id_pagamento_default="id_pagamento_default"
                            :id_azienda="selected_item.id_azienda"
                        />
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </template>

        <v-dialog v-model="graphDialog" width="80vw">
            <v-toolbar class="white--text" color="indigo" dense>
                <v-toolbar-title>Quick Graph</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            class="mr-5"
                            @click="graphDialog = false"
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon color="error">mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Chiudi</span>
                </v-tooltip>
            </v-toolbar>
            <v-card height="80vh" style="overflow-y: scroll">
                <WindowFrame
                    component="graph"
                    :input_args="graphArgs"
                    :key="graphKey"
                >
                </WindowFrame>
            </v-card>
        </v-dialog>

        <!--<v-dialog v-model="DettaglioDialog" width="40vw">
      <v-card>
        <v-toolbar class="white--text" color="indigo" dense>
          <v-toolbar-title>Seleziona Dettaglio</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="SelectDettaglio"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="DettaglioDialog = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-autocomplete
          class="ma-3"
          :items="dettagli_servizio"
          item-value="id_servizio_dettaglio"
          item-text="descrizione"
          v-model="dettaglio_sel"
        ></v-autocomplete>
      </v-card>
    </v-dialog>-->

        <!-- Dialog Delete -->
        <v-dialog persistent v-model="delete_dialog" width="550px">
            <v-card min-height="25vh">
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        Elimina
                    </v-toolbar-title>
                    <v-spacer />
                    <!-- Pulsante di conferma eliminazione -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-auto mr-5"
                                @click="setEliminaServiziMultipli()"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Conferma</span>
                    </v-tooltip>
                    <v-spacer />
                    <!-- Pulsante annulla eliminazione -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                small
                                @click="delete_dialog = false"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <br />
                <v-card-text class="mt-10">
                    <h2>
                        Sei sicuro di voler eliminare i servizi selezionati?
                    </h2>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog ripianifica -->
        <v-dialog persistent v-model="ripianifica_dialog" width="550px">
            <v-card min-height="25vh">
                <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                    <v-toolbar-title class="white--text">
                        Ripianifica
                    </v-toolbar-title>
                    <v-spacer />
                    <!-- Pulsante di conferma ripianificazione -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-auto mr-5"
                                @click="setRipianificaServiziMultipli()"
                                v-bind="attrs"
                                v-on="on"
                                small
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Conferma</span>
                    </v-tooltip>
                    <v-spacer />
                    <!-- Pulsante annulla eliminazione -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                small
                                @click="ripianifica_dialog = false"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <br />
                <v-card-text class="mt-10">
                    <h2>
                        Sei sicuro di voler ripianificare i servizi selezionati?
                    </h2>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog gestione aziende -->
        <v-dialog
            persistent
            class="ma-0 pa-0"
            v-model="dialog_gestione_aziende"
        >
            <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                <v-toolbar-title class="white--text">
                    Gestione Aziende
                </v-toolbar-title>
                <v-spacer />
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="dialog_gestione_aziende = false"
                            class="ml-auto"
                            v-bind="attrs"
                            v-on="on"
                            small
                        >
                            <v-icon color="error"> mdi-close </v-icon>
                        </v-btn>
                    </template>
                    <span>Chiudi</span>
                </v-tooltip>
            </v-toolbar>
            <v-card class="ma-0 pa-0" height="85vh" style="overflow: hidden">
                <div style="position: relative; height: 100%" class="ma-0 pa-0">
                    <WindowFrame
                        class="ma-n3 pa-0"
                        :component="componenteWF"
                        ref="windowframe"
                        :input_args="inputArgs"
                    />
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_pdf" width="1030">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text">
                        Report Servizi</v-toolbar-title
                    >
                    <v-spacer></v-spacer>

                    <v-tooltip bottom v-if="multi_page">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="
                                    current_page > 0
                                        ? current_page--
                                        : (current_page = current_page)
                                "
                                small
                                class="mr-10"
                            >
                                <v-icon color="primary">
                                    mdi-arrow-left
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Pagina precedente</span>
                    </v-tooltip>

                    <v-tooltip bottom v-if="multi_page">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="
                                    current_page < pdfs.length - 1
                                        ? current_page++
                                        : (current_page = current_page)
                                "
                                small
                            >
                                <v-icon color="primary">
                                    mdi-arrow-right
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Prossima pagina</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="dialog_pdf = false" small>
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-progress-linear
                    indeterminate
                    color="cyan"
                    v-if="loading"
                    id="progress"
                >
                </v-progress-linear>
                <v-col cols="12">
                    <iframe
                        :src="multi_page ? pdfs[current_page] : iframeUrl"
                        frameborder="0"
                        style="
                            height: 70vh !important;
                            width: 1000px !important;
                        "
                    >
                    </iframe>
                </v-col>
            </v-card>
        </v-dialog>

        <!-- DIALOG SERVIZI SUGGERITI -->
        <v-dialog v-model="dialog_servizi_suggeriti" width="80%">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text"
                        >Servizi Suggeriti</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                class="mr-2"
                                v-on="on"
                                @click="openMaps"
                                small
                            >
                                <v-icon color="primary">
                                    mdi-google-maps
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Visualizza mappa</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small @click="salvaAssociazione">
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva e associa</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="
                                    dialog_servizi_suggeriti = false;
                                    servizi_suggeriti = [];
                                "
                                small
                            >
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-progress-linear indeterminate color="cyan" v-if="loading">
                </v-progress-linear>
                <v-data-table
                    :headers="headers_suggeriti"
                    fixed-header
                    :items="
                        servizi_suggeriti?.filter(
                            (e) => e.id_servizio != servizio_sel?.id_servizio
                        )
                    "
                    item-key="id_servizio"
                    class="elevation-1"
                    calculate-widths
                >
                    <template v-slot:[`item.seleziona`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    @click="selezionaAssocia(item)"
                                >
                                    <v-icon
                                        :color="
                                            item.selezionato
                                                ? 'success'
                                                : 'primary'
                                        "
                                        >{{
                                            item.selezionato
                                                ? "mdi-check"
                                                : "mdi-plus"
                                        }}</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>Aggiungi</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.ora_inizio_attivita`]="{ item }">
                        <div
                            :style="{
                                borderRadius: 8 + 'px',
                                padding: 4 + 'px',
                                backgroundColor:
                                    item.ora_inizio_attivita < '13:30'
                                        ? 'cyan'
                                        : 'orange',
                            }"
                        >
                            {{ item.ora_inizio_attivita }}
                        </div>
                    </template>
                </v-data-table>
            </v-card>
        </v-dialog>

        <!-- DIALOG GESTIONE PIANIFICAZIONE-->
        <v-dialog v-model="dialog_gestione_pianificazione" width="60%">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text"
                        >Gestisci Pianificazione</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                class="mr-2"
                                v-on="on"
                                small
                                @click="eliminaServizio"
                            >
                                <v-icon color="error"> mdi-delete </v-icon>
                            </v-btn>
                        </template>
                        <span>Elimina le schedulazioni</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                small
                                @click="ripianificaEServiziSuggeriti"
                            >
                                <v-icon color="primary">
                                    mdi-delete-clock
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Elimina e pianifica l'associazione</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="
                                    dialog_gestione_pianificazione = false;
                                    servizio_sel = null;
                                "
                                small
                            >
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-container>
                    <v-row class="ma-4">
                        Il servizio selezionato è associato ad un altro
                        servizio. Vuoi eliminare entrambe le schedulazioni, o
                        ripianificare il sottostante?
                    </v-row>
                    <v-row>
                        <v-data-table
                            :headers="headers_servizio_associato"
                            fixed-header
                            :items="
                                servizio_pianificato_sel?.servizio_successivo !=
                                null
                                    ? [
                                          servizio_pianificato_sel?.servizio_successivo,
                                      ]
                                    : [
                                          servizio_pianificato_sel?.servizio_precedente,
                                      ]
                            "
                        >
                            <template v-slot:[`item.ripianifica`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            @click="eliminaEPianifica(item)"
                                        >
                                            <v-icon color="success"
                                                >mdi-floppy</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>Schedula</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <!-- DIALOG GESTIONE PIANIFICAZIONE-->
        <v-dialog v-model="dialog_elimina_sched" width="500px">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text"
                        >Gestisci Pianificazione</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                class="mr-2"
                                v-on="on"
                                small
                                @click="eliminaServizio"
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Slava</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="
                                    dialog_elimina_sched = false;
                                    servizio_sel = null;
                                "
                                small
                            >
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-container>
                    <v-row class="ma-4">
                        Vuoi eliminare la schedulazione del servizio
                        {{ servizio_sel?.codice }}?
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <!-- DIALOG MAPS -->
        <v-dialog v-model="dialog_maps" width="98%">
            <v-card
                class="ma-0 pa-0"
                height="calc(100vh - 100px)"
                style="overflow: hidden"
            >
                <div style="position: relative; height: 100%">
                    <WindowFrame
                        class="ma-0 pa-0"
                        @chiudi="
                            dialog_maps = false;
                            key_geo == 1 ? 0 : 1;
                        "
                        :component="'geolocation'"
                        :key="key_geo"
                        ref="windowframe_geo"
                        :input_args="input_args"
                    />
                </div>
            </v-card>
        </v-dialog>
        <!-- Dialog gestione aziende -->

        <!-- <v-dialog persistent v-model="dialog_gestione_aziende2">
            <QLDialog2Aziende
                @aggiornaItemsAzienda="aggiornaAutocomplete()"
                @chiudiDialog="dialog_gestione_aziende2 = false"
            />
        </v-dialog> -->
        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />
        <!-- Overlay di caricamento -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<script>
import QLGenerale from "./QLCOMPONENTS/QLServizi/QLGeneraleServizi.vue";
import QLOpzioni from "./QLCOMPONENTS/QLServizi/QLOpzioniServizi.vue";
//import QLDialogAziende from "./QLCOMPONENTS/QLServizi/QLDialogAziende.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
// import QLDialog2Aziende from "./QLCOMPONENTS/QLServizi/QLDialog2Aziende.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import moment from "moment/moment";

class Servizio {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutti i campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "id_servizio", default_val: null },
            { nome: "id_azienda", default_val: null },
            { nome: "codice", default_val: "" },
            { nome: "data_richiesta", default_val: "" },
            {
                nome: "data_inizio",
                default_val: moment().add(1, "d").format("YYYY-MM-DD"),
            },
            {
                nome: "data_fine",
                default_val: moment().add(1, "d").format("YYYY-MM-DD"),
            },
            { nome: "localita_partenza", default_val: "" },
            { nome: "provincia_partenza", default_val: "" },
            { nome: "cap_partenza", default_val: null },
            { nome: "indirizzo_partenza", default_val: "" },
            { nome: "civico_partenza", default_val: null },

            { nome: "id_azienda_dest", default_val: null },
            { nome: "id_sede_dest_senza_deposito", default_val: "" },
            { nome: "localita_dest_senza_deposito", default_val: "" },
            { nome: "provincia_dest_senza_deposito", default_val: "" },
            { nome: "cap_dest_senza_deposito", default_val: null },
            { nome: "indirizzo_dest_senza_deposito", default_val: "" },
            { nome: "civico_dest_senza_deposito", default_val: null },

            { nome: "id_fascia_oraria", default_val: "" },
            { nome: "id_tipo_formulario", default_val: "" },
            { nome: "id_causale_formulario", default_val: "" },

            { nome: "localita_arrivo", default_val: "" },
            { nome: "provincia_arrivo", default_val: "" },
            { nome: "cap_arrivo", default_val: null },
            { nome: "indirizzo_arrivo", default_val: "" },
            { nome: "distanza", default_val: null },
            { nome: "tempo_percorrenza", default_val: null },
            { nome: "id_sede_arrivo", default_val: "" },
            { nome: "id_zona", default_val: "" },
            { nome: "riferimento", default_val: "" },
            { nome: "id_dashboard", default_val: -1 },
            { nome: "ora_inizio", default_val: "" },
            { nome: "ora_fine", default_val: "" },
            { nome: "attesa_carico", default_val: 0 },
            { nome: "attesa_carico_valore", default_val: 0 },
            { nome: "attesa_carico_um", default_val: 0 },
            { nome: "civico_arrivo", default_val: null },
            { nome: "referente", default_val: null },
            { nome: "cellulare", default_val: "" },
            { nome: "descrizione", default_val: "" },
            { nome: "festivo_compreso", default_val: 0 },
            { nome: "sabato_compreso", default_val: 0 },
            { nome: "domenica_compreso", default_val: 0 },
            { nome: "tempo_setup_partenza", default_val: 30 },
            { nome: "tempo_setup_arrivo", default_val: 30 },
            { nome: "pianificato", default_val: 0 },
            { nome: "errori", default_val: {} },
            { nome: "validita", default_val: 1 },
        ];

        return campi;
    }
}
export default {
    name: "QLServizi",

    components: {
        QLGenerale,
        QLOpzioni,
        //QLDialogAziende,
        // QLDialog2Aziende,
        SnackbarQV,
        WindowFrame,
    },

    props: {},

    data() {
        return {
            // Variabili d'appoggio

            current_page: 0,
            dettaglio_sel: null,
            change_state: false,
            //DettaglioDialog: false,
            inputArgs: { landing_page: "/" },
            componenteWF: "",
            tab: 0,
            data_inizio_menu: "",
            data_fine_menu: "",
            id_pagamento_default: null,
            iframeUrl: null,
            azienda_detail: {},
            overlay: false,
            dettaglio: null,
            graphDialog: false,
            graphKey: false,
            carica_dettaglio: false,
            page_num: 1,
            items_per_page: 10,
            is_selez_multipla: false,
            graphArgs: {
                evento_target: "load_dashboard",
                payload: {
                    version: 0,
                    dashboard: -1,
                    params: [],
                },
            },
            // servizio selezionato
            selected_item: new Servizio(),
            servizio_ass_sel: null,
            servizio_sel: null,
            servizio_pianificato_sel: null,
            servizio_pianificato_dettaglio_sel: null,

            // Filtri
            azienda_filter: "",
            codice_filter: "",
            localita_partenza_filter: "",
            localita_arrivo_filter: "",
            descrizione_filter: "",
            data_inizio_filter: "",
            data_fine_filter: "",
            interval: null,
            // Variabili tabella/filtri
            data_table: true,
            filters: false,
            multi_page: false,
            data_table_key: false,
            key_geo: 1,
            // Modal
            dialog_elimina_sched: false,
            dialog_gestione_aziende: false,
            dialog_gestione_aziende2: false,
            dialog_gestione_pianificazione: false,
            dialog_maps: false,
            dialog_servizi_suggeriti: false,
            delete_dialog: false,
            ripianifica_dialog: false,
            dialog_extra: false,
            dialog_pdf: false,
            loading: false,

            // Array
            dashboards: [],
            dettagli_servizio: [],
            items_azienda: [],
            pdfs: [],
            selected_options: [],
            // servizi visibili
            servizi: [],
            // totale servizi
            tot_servizi: [],
            // Headers Tabella
            servizi_suggeriti: [],
            input_args: {},
            headers: [
                {
                    text: "Seleziona",
                    value: "select",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Modifica",
                    value: "edit",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Report",
                    value: "report",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Pianificato",
                    value: "pianificato",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Maps",
                    value: "google",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Codice",
                    value: "codice",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Ragione Sociale",
                    value: "id_azienda",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tipo Servizio",
                    value: "tipo_servizio",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Destinazione",
                    value: "indirizzo_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Data inizio",
                    value: "data_inizio",
                    filterable: false,
                    sortable: false,
                },
                // {
                //   text: "Ora Inizio",
                //   value: "inizio_attivita",
                //   filterable: false,
                //   sortable: false,
                // },
                {
                    text: "Ora arrivo presso cantiere",
                    value: "data_ora_arrivo_cantiere",
                    filterable: false,
                    sortable: false,
                },
                // {
                //   text: "Data fine",
                //   value: "data_fine",
                //   filterable: false,
                //   sortable: false,
                // },
                {
                    text: "Stato",
                    value: "des_stato",
                    filterable: false,
                    sortable: false,
                },
                // {
                //   text: "Elimina",
                //   value: "delete",
                //   filterable: false,
                //   sortable: false,
                // },
            ],
            headers_servizio_associato: [
                {
                    text: "Ripianifica",
                    value: "ripianifica",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Codice",
                    value: "codice",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Ragione Sociale",
                    value: "cliente",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Destinazione",
                    value: "destinazione",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Mezzo",
                    value: "mezzo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Partenza",
                    value: "partenza",
                    filterable: false,
                    sortable: false,
                },
            ],
            headers_suggeriti: [
                {
                    text: "Seleziona",
                    value: "seleziona",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Codice",
                    value: "codice",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Ragione Sociale",
                    value: "ragione_sociale",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Servizio",
                    value: "servizio",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Volume",
                    value: "volume",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tipo Materiale",
                    value: "tipo_materiale",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Località",
                    value: "localita_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Destinazione",
                    value: "indirizzo_arrivo",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Distanza",
                    value: "distanza_text",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Tempo percorrenza",
                    value: "tempo_percorrenza_text",
                    filterable: false,
                    sortable: false,
                },

                {
                    text: "Data Inizio Attività",
                    value: "inizio_attivita",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Ora Inizio Attività",
                    value: "ora_inizio_attivita",
                    filterable: false,
                    sortable: false,
                },
                // {
                //   text: "Data Fine Attività",
                //   value: "fine_attivita",
                //   filterable: false,
                //   sortable: false,
                // },
                {
                    text: "Ore Fine Attività",
                    value: "ora_fine_attivita",
                    filterable: false,
                    sortable: false,
                },
            ],
            items_stato: [],
        };
    },

    computed: {},

    watch: {
        data_table: {
            immediate: true,
            handler() {
                if (sessionStorage.getItem("page_servizi"))
                    this.page_num = parseInt(
                        sessionStorage.getItem("page_servizi")
                    );

                this.servizi.forEach((e) => {
                    this.$set(e, "selected", false);
                });
            },
        },

        is_selez_multipla: {
            immediate: true,
            handler() {
                let h_sel = this.headers.find((e) => {
                    return e.value == "select";
                });

                if (h_sel) this.$set(h_sel, "visible", this.is_selez_multipla);
                if (!this.is_selez_multipla) {
                    this.servizi.forEach((e) => {
                        this.$set(e, "selected", false);
                    });
                }

                this.data_table_key = !this.data_table_key;
            },
        },
    },

    methods: {
        eliminaEPianifica(item) {
            let obj_sel = null;
            this.servizi.forEach((e) => {
                if (e.id_servizio == item.id_servizio) {
                    obj_sel = e;
                }
            });
            this.eliminaServizio();

            const getserviziodettagli = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getserviziodettagli",
                    id_servizio: obj_sel.id_servizio,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", getserviziodettagli).then((res) => {
                this.overlay = false;
                if (res.status === 200) {
                    this.servizio_pianificato_dettaglio_sel =
                        res.data.result[0];
                    const pianificazione = {
                        controller: "logistic",
                        method: "POST",
                        richiesta: {
                            token: localStorage.getItem("user_token"),
                            action: "saveserviziopianifica",
                            servizio: obj_sel,
                            dettagli: [this.servizio_pianificato_dettaglio_sel],
                        },
                    };

                    this.overlay = true;
                    this.data_table = true;
                    this.$store.dispatch("api6", pianificazione).then((res) => {
                        this.overlay = false;
                        console.log("res", res);

                        if (res.status === 200) {
                            if (res.data.result[0].pianificazione_result == 1) {
                                this.$refs.SnackbarQV.print(
                                    "success",
                                    "Servizio ripianificato correttamente."
                                );
                            } else {
                                this.$refs.SnackbarQV.print(
                                    "orange",
                                    res.data.result[0].descrizione
                                );
                            }
                        } else {
                            // snackbar errore
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Errore di comunicazione col server, non è stato possibile caricare i dati."
                            );
                        }

                        this.getServizi();
                    });
                } else {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });

            this.dialog_gestione_pianificazione = false;
            this.dialog_servizi_suggeriti = false;
            this.servizio_pianificato_dettaglio_sel = null;
            this.servizio_ass_sel = null;
            this.servizio_associato_da_pianificare = null;
            this.servizio_pianificato_sel = null;
        },
        eliminaPianificaEAssocia() {
            this.servizio_associato_da_pianificare.id_servizio_associato = this
                .servizio_ass_sel
                ? this.servizio_ass_sel
                : null;

            const pianificazione = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "saveserviziopianifica",
                    servizio: this.servizio_associato_da_pianificare,
                    dettagli: [this.servizio_pianificato_dettaglio_sel],
                },
            };

            this.overlay = true;
            this.data_table = true;
            this.$store.dispatch("api6", pianificazione).then((res) => {
                this.overlay = false;
                if (res.status === 200) {
                    if (res.data.result[0].pianificazione_result == 1) {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Servizio ripianificato correttamente."
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            res.data.result[0].descrizione
                        );
                    }

                    if (this.servizio_pianificato_sel != null) {
                        this.eliminaServizio();
                    } else {
                        this.getServizi();
                    }
                } else {
                    // snackbar errore
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }

                this.dialog_gestione_pianificazione = false;
                this.dialog_servizi_suggeriti = false;
                this.servizio_pianificato_dettaglio_sel = null;
                this.servizio_ass_sel = null;
                this.servizio_associato_da_pianificare = null;
                this.servizio_pianificato_sel = null;
            });
        },
        ripianificaEServiziSuggeriti() {
            this.servizi.forEach((e) => {
                if (
                    e.id_servizio ==
                        this.servizio_pianificato_sel.servizio_successivo
                            ?.id_servizio ||
                    e.id_servizio ==
                        this.servizio_pianificato_sel.servizio_precedente
                            ?.id_servizio
                ) {
                    this.servizio_associato_da_pianificare = e;
                }
            });

            const getserviziodettagli = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getserviziodettagli",
                    id_servizio:
                        this.servizio_associato_da_pianificare.id_servizio,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", getserviziodettagli).then((res) => {
                this.overlay = false;
                if (res.status === 200) {
                    this.servizio_pianificato_dettaglio_sel =
                        res.data.result[0];
                    console.log(
                        "servizio per la chiamata dei servizi suggeriti",
                        this.servizio_pianificato_dettaglio_sel
                    );
                    this.serviziSuggeritiFromPianificazione();
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        clickIconPianificazione(item) {
            console.log("click ass", item);
            this.servizio_sel = item;
            if (
                item.id_servizio_successivo != 0 ||
                item.id_servizio_precedente != 0
            ) {
                this.servizio_pianificato_sel = item;
                this.dialog_gestione_pianificazione = true;
                console.log(
                    "click pianificazione dialog",
                    this.servizio_pianificato_sel
                );
            } else if (item.pianificato == 1) {
                this.dialog_elimina_sched = true;
            } else {
                return;
            }
        },
        salvaAssociazione() {
            if (this.servizi_suggeriti.length != 0) {
                this.servizio_ass_sel = this.servizi_suggeriti.filter(
                    (e) => e.selezionato == true
                )[0]
                    ? this.servizi_suggeriti.filter(
                          (e) => e.selezionato == true
                      )[0].id_servizio
                    : null;
                console.log("salva associazione", this.servizio_ass_sel);
            }

            if (this.servizio_ass_sel != null) {
                this.salvaPianificazione();
                this.dialog_servizi_suggeriti = false;
                this.servizi_suggeriti = [];
            } else {
                this.$refs.SnackbarQV.print(
                    "error",
                    "Selezionare un servizio per l'associazione."
                );
            }
        },
        allReport() {
            this.overlay = true;
            let arr_ids = [];
            console.log("servizi", this.servizi);
            if (this.servizi.length != 0) {
                this.servizi.forEach((e) => {
                    arr_ids.push(e.id_servizio);
                });
            }

            let request = {
                controller: "report",
                method: "POST",
                richiesta: {
                    action: "getreportpdf",
                    token: localStorage.user_token,
                    cod_report: "scheda_servizio",
                    parametri: [
                        {
                            parametro: "@id_servizio",
                            valore: arr_ids.toString(),
                        },
                    ],
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        if (
                            "tipo_messaggio" in res.data &&
                            "query_messaggio" in res.data &&
                            res.data.tipo_messaggio == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.query_messaggio
                            );
                        }
                        const response = res.data.result;
                        const byteCharacters = atob(response);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                            type: "application/pdf",
                        });
                        const blobUrl = URL.createObjectURL(blob);
                        this.iframeUrl = blobUrl;
                        this.dialog_pdf = true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Impossibile generare il report"
                        );
                    }
                    this.overlay = false;
                })
                .catch((err) => {
                    this.overlay = false;
                    if (
                        "tipo_messaggio" in err.response.data &&
                        "query_messaggio" in err.response.data &&
                        err.response.data.tipo_messaggio == 2
                    ) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            err.response.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print("error", err.toString());
                    }
                });
        },
        async cambiaStato() {
            await this.getDettagliServizio();
            console.log("dettaglio?", this.dettagli_servizio);
            // Se cambio lo stato da riga tabella
            this.dettagli_servizio.forEach((e) => {
                e.id_stato = this.items_stato.filter(
                    (s) => s.des == this.selected_item.des_stato
                )[0].id_tabella;
            });
            console.log("QLServizio - saveservizio");
            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "saveservizio",
                    token: localStorage.getItem("user_token"),
                    servizio: this.selected_item,
                    dettagli: this.dettagli_servizio,
                },
            };

            // Overlay di caricamento
            this.overlay = true;
            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Servizio salvato correttamente."
                        );
                        this.getServizi();
                        this.selected_item = {};
                        this.dettagli_servizio = [];
                    }
                })
                .catch((e) => {
                    // stampo l'errore
                    console.error(e);
                    // snackbar avvertimento
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    // tolgo l'overlay
                    this.overlay = false;
                });
        },
        changeState(arg) {
            console.log("change state arg", arg);
            this.selected_item = arg;
            this.cambiaStato();
        },
        getReport(item) {
            this.overlay = true;
            this.pdfs = [];
            let request = {
                controller: "report",
                method: "POST",
                richiesta: {
                    action: "getreportpdf",
                    token: localStorage.user_token,
                    cod_report: "scheda_servizio",
                    parametri: [
                        {
                            parametro: "@id_servizio",
                            valore: item.id_servizio,
                        },
                    ],
                },
            };

            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        if (
                            "tipo_messaggio" in res.data &&
                            "query_messaggio" in res.data &&
                            res.data.tipo_messaggio == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.query_messaggio
                            );
                        }
                        const response = res.data.result;
                        const byteCharacters = atob(response);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                            type: "application/pdf",
                        });
                        const blobUrl = URL.createObjectURL(blob);
                        this.iframeUrl = blobUrl;
                        this.dialog_pdf = true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Impossibile generare il report"
                        );
                    }
                    this.overlay = false;
                })
                .catch((err) => {
                    this.overlay = false;
                    if (
                        "tipo_messaggio" in err.response.data &&
                        "query_messaggio" in err.response.data &&
                        err.response.data.tipo_messaggio == 2
                    ) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            err.response.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print("error", err.toString());
                    }
                });
        },
        getItemsStato() {
            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    tipo: "STATO_SERVIZIO_DETTAGLIO",
                    filter: `validita = 1`,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", request).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.items_stato = res.data ? res.data : [];
                    console.log("items stato:", this.items_stato);
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                }
            });
        },
        OpenGraph() {
            console.log(this.selected_item, this.dettagli_servizio);
            this.graphArgs.payload.dashboard = this.selected_item.id_dashboard;
            this.graphArgs.payload.params = [];
            this.graphArgs.payload.params.push({
                simbolo: "$id_servizio",
                valore: this.selected_item.id_servizio,
            });
            this.graphArgs.payload.params.push({
                simbolo: "$id_azienda",
                valore: this.selected_item.id_azienda,
            });
            /*if (this.dettagli_servizio.length == 1) {
        this.graphArgs.payload.params.push({
          simbolo: "$id_servizio_dettaglio",
          valore: this.dettagli_servizio[0].id_servizio_dettaglio,
        });
      } else {
        this.DettaglioDialog = true;
        return;
      }*/
            this.graphKey = !this.graphKey;
            this.graphDialog = true;
        },
        openMaps() {
            let arr = [];
            this.servizi_suggeriti.forEach((e) => {
                if (e.selezionato) {
                    let obj = { codice: e.codice };
                    arr.push(obj);
                }
            });

            let obj_selected = {
                codice:
                    this.selected_item.codice != ""
                        ? this.selected_item.codice
                        : this.servizio_sel.codice,
            };

            arr.push(obj_selected);

            this.input_args.servizi_suggeriti = arr;
            console.log("codici suggeriti", this.input_args);
            this.input_args.data = this.selected_item.data_inizio;
            this.key_geo = this.key_geo == 1 ? 0 : 1;
            this.dialog_maps = true;
        },

        selezionaServiziPagina() {
            var start = this.items_per_page * (this.page_num - 1);
            var end =
                start + this.items_per_page < this.servizi.length
                    ? start + this.items_per_page
                    : this.servizi.length;
            var select = false;

            for (var i = start; i < end; i++) {
                if (!this.servizi[i].selected) {
                    select = true;
                    break;
                }
            }

            for (i = start; i < end; i++)
                this.$set(this.servizi[i], "selected", select);

            //this.data_table_key = !this.data_table_key;
        },

        SelectDettaglio() {
            this.DettaglioDialog = false;
            this.graphArgs.payload.params.push({
                simbolo: "$id_servizio_dettaglio",
                valore: this.dettaglio_sel,
            });
            this.graphKey = !this.graphKey;
            this.graphDialog = true;
        },
        async ApriAnagrafica() {
            var menuItem;
            let request = {
                controller: "Global",
                method: "POST",
                richiesta: {
                    action: "getmenuparametri",
                    token: localStorage.getItem("user_token"),
                    cod_modulo: "quickproject",
                },
            };

            await this.$store
                .dispatch("api6", request)
                .then((res) => {
                    menuItem = res.data.result.moduli[0].moduli_menu.filter(
                        (e) => e.path == "/clienti/anagrafiche"
                    )[0];
                })
                .catch((err) => {
                    console.log(err);
                });

            this.inputArgs.landing_page =
                menuItem.path + "/" + menuItem.id_modulo_menu;
            this.componenteWF = "contabilita";
            this.dialog_gestione_aziende = true;
        },
        formatData(item) {
            if (item != "") {
                console.log(
                    "formatdata item",
                    moment(item).format("DD/MM/YYYY")
                );
                return moment(item).format("DD/MM/YYYY");
            }
        },
        // metodo per rimettere la tab Generale quando
        // l'utente torna alla tabella dei servizi
        resetTab() {
            this.data_table = true;
            this.tab = 0;
        },
        // Servizio selezionato

        pageChange(page) {
            this.page_num = page;
            sessionStorage.setItem("page_servizi", page);
        },

        selectItem(item) {
            console.log("dettaglio", item);
            this.selected_item = new Servizio(JSON.parse(JSON.stringify(item)));

            // if (this.selected_item.errori) {
            //   this.selected_item.errori = JSON.parse(this.selected_item.errori);
            // }
            (this.selected_item.colore_sfondo = {
                hex: item.colore_sfondo,
            }),
                (this.selected_item.colore_testo = {
                    hex: item.colore_testo,
                }),
                console.log(this.selected_item);
            this.getDettagliServizio();
        },
        async getDettagliServizio() {
            if (this.selected_item.id_servizio != null) {
                const getserviziodettagli = {
                    controller: "logistic",
                    method: "POST",
                    richiesta: {
                        token: localStorage.getItem("user_token"),
                        action: "getserviziodettagli",
                        id_servizio: this.selected_item.id_servizio,
                    },
                };
                this.overlay = true;
                await this.$store
                    .dispatch("api6", getserviziodettagli)
                    .then((res) => {
                        this.overlay = false;
                        if (res.status === 200 || res.status === 204) {
                            this.dettagli_servizio = [];
                            res.data.result.forEach((e) => {
                                if (e.validita === 1) {
                                    this.dettagli_servizio.push(e);
                                }
                            });
                            return true;
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                            );
                            return false;
                        }
                    });
            }
        },
        // Nuovo Servizio
        nuovoServizio() {
            this.dettagli_servizio = [];
            this.data_table = false;
            this.tab = 1;
            this.carica_dettaglio = false;

            this.selected_item = new Servizio();
            this.selected_item.colore_sfondo = { hex: "#1976D2" };
            this.selected_item.colore_testo = { hex: "#000000" };
            this.getConfig();
        },
        // metodo per riempire gli array che danno
        // gli items agli autocomplete
        aggiornaAutocomplete() {
            this.items_azienda = [];
            this.servizi.forEach((e) => {
                this.items_azienda.push({
                    ragione_sociale: e.des_azienda,
                    id_anagrafica: e.id_azienda,
                });
            });
        },

        async getAziende() {
            const getragionesociale = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getaziende",
                    id_anagrafica: this.selected_item.id_azienda,
                },
            };
            this.overlay = true;
            return this.$store
                .dispatch("api6", getragionesociale)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        if (res.data.result.length > 0)
                            this.azienda_detail = res.data.result[0];
                        return true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                        return false;
                    }
                });
        },
        eliminaServizio() {
            const request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "delete",
                    id_servizio: this.servizio_pianificato_sel
                        ? this.servizio_pianificato_sel.id_servizio
                        : this.servizio_sel.id_servizio,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", request).then((res) => {
                this.overlay = false;
                if (res.status === 200 || res.status === 204) {
                    this.dialog_gestione_pianificazione = false;
                    this.$refs.SnackbarQV.print("success", `Dati salvati`);
                    this.dialog_gestione_pianificazione = false;
                    this.dialog_elimina_sched = false;
                    this.servizio_pianificato_sel = null;
                    this.servizio_pianificato_dettaglio_sel = null;
                    this.servizio_sel = null;
                    this.servizio_ass_sel = null;
                    this.getServizi();
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        getConfig() {
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getconfig",
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", getconfig).then((res) => {
                this.overlay = false;
                if (res.status === 200 || res.status === 204) {
                    this.selected_item.localita_partenza =
                        res.data.result.localita_partenza;
                    this.selected_item.provincia_partenza =
                        res.data.result.provincia_partenza;
                    this.selected_item.indirizzo_partenza =
                        res.data.result.indirizzo_partenza;
                    this.selected_item.civico_partenza =
                        res.data.result.civico_partenza;
                    this.selected_item.cap_partenza =
                        res.data.result.cap_partenza;
                    this.selected_item.tempo_setup_partenza =
                        res.data.result.tempo_setup_partenza;
                    this.selected_item.tempo_setup_arrivo =
                        res.data.result.tempo_setup_arrivo;
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            });
        },
        // metodo per riempire gli array
        // dei servizi
        getServizi() {
            const getservizi = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getservizi",
                    id_servizio: null,
                },
            };
            this.overlay = true;
            this.$store
                .dispatch("api", getservizi)
                .then((res) => {
                    this.overlay = false;
                    console.log("res get servizi", res);

                    if (res.status == 200) {
                        this.servizi = [];
                        this.tot_servizi = [];
                        // res.data.result.forEach((e) => {
                        //   e.tipo_servizio = e.volume != null ? e.servizio + " " + e.volume + " MQ " + e.tipo_materiale : e.servizio;
                        //   e.inizio_attivita = e.inizio_attivita ? moment(e.inizio_attivita).format(
                        //     "HH:mm") : "";
                        //   e.data_ora_arrivo_cantiere = e.data_ora_arrivo_cantiere ? moment(e.data_ora_arrivo_cantiere).format(
                        //     "HH:mm") : "";
                        //   this.tot_servizi.push(e);
                        // });
                        this.tot_servizi = res.data.result;
                        this.tot_servizi = this.tot_servizi.reverse();
                        this.tot_servizi.sort(
                            (a, b) =>
                                new Date(a.data_inizio) -
                                new Date(b.data_inizio)
                        );
                        this.servizi = Array.from(this.tot_servizi);
                        console.log(
                            "servizi tot",
                            this.tot_servizi,
                            this.servizi
                        );

                        this.aggiornaAutocomplete();
                        this.data_inizio_filter = moment().format("YYYY-MM-DD");
                        this.filtra();
                    } else {
                        this.overlay = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    this.overlay = false;
                });
        },
        openServiziSuggeriti() {
            if (
                (this.$refs.createDettaglio.selected_item.id_tipo_macchina ==
                    null ||
                    this.$refs.createDettaglio.selected_item.um_volume ==
                        null) &&
                this.dettagli_servizio.length == 0
            ) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    `Dati opzioni servizio non completi.`
                );
                return;
            }

            this.dialog_servizi_suggeriti = true;
            this.loading = true;

            const getservizi = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "abbinamentipossibili",
                    id_servizio:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0].id_servizio
                            : this.$refs.createDettaglio.selected_item
                                  .id_servizio,
                    data_viaggi: this.selected_item.data_inizio,
                    localita_partenza: this.selected_item.localita_partenza,
                    provincia_partenza: this.selected_item.provincia_partenza,
                    cap_partenza: this.selected_item.cap_partenza,
                    indirizzo_partenza: this.selected_item.indirizzo_partenza,
                    civico_partenza: this.selected_item.civico_partenza,
                    localita_arrivo: this.selected_item.localita_arrivo,
                    provincia_arrivo: this.selected_item.provincia_arrivo,
                    cap_arrivo: this.selected_item.cap_arrivo,
                    id_fascia_oraria: this.selected_item.id_fascia_oraria,
                    indirizzo_arrivo: this.selected_item.indirizzo_arrivo,
                    civico_arrivo: this.selected_item.civico_arrivo,

                    id_sede_dest_senza_deposito: this.selected_item
                        .id_sede_dest_senza_deposito
                        ? this.selected_item.id_sede_dest_senza_deposito
                        : null,
                    localita_dest_senza_deposito: this.selected_item
                        .localita_dest_senza_deposito
                        ? this.selected_item.localita_dest_senza_deposito
                        : null,
                    provincia_dest_senza_deposito: this.selected_item
                        .provincia_dest_senza_deposito
                        ? this.selected_item.provincia_dest_senza_deposito
                        : null,
                    cap_dest_senza_deposito: this.selected_item
                        .cap_dest_senza_deposito
                        ? this.selected_item.cap_dest_senza_deposito
                        : null,
                    indirizzo_dest_senza_deposito: this.selected_item
                        .indirizzo_dest_senza_deposito
                        ? this.selected_item.indirizzo_dest_senza_deposito
                        : null,
                    civico_dest_senza_deposito: this.selected_item
                        .civico_dest_senza_deposito
                        ? this.selected_item.civico_dest_senza_deposito
                        : null,
                    latitudine_dest_senza_deposito: this.selected_item
                        .latitudine_dest_senza_deposito
                        ? this.selected_item.latitudine_dest_senza_deposito
                        : null,
                    longitudine_dest_senza_deposito: this.selected_item
                        .longitudine_dest_senza_deposito
                        ? this.selected_item.longitudine_dest_senza_deposito
                        : null,

                    ora_inizio:
                        this.selected_item.ora_inizio == ""
                            ? null
                            : this.selected_item.ora_inizio,
                    id_tipo_servizio_dettaglio:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0]
                                  .id_tipo_servizio_dettaglio
                            : this.$refs.createDettaglio.selected_item
                                  .id_tipo_servizio_dettaglio,
                    id_tipo_materiale:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0].id_tipo_materiale
                            : this.$refs.createDettaglio.selected_item
                                  .id_tipo_materiale,
                    id_tipo_macchina:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0].id_tipo_macchina
                            : this.$refs.createDettaglio.selected_item
                                  .id_tipo_macchina,
                    volume:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0].volume
                            : this.$refs.createDettaglio.selected_item.volume,
                    um_volume:
                        this.dettagli_servizio.length != 0
                            ? this.dettagli_servizio[0].um_volume
                            : this.$refs.createDettaglio.selected_item
                                  .um_volume,
                },
            };
            this.$store
                .dispatch("api6", getservizi)
                .then((res) => {
                    this.loading = false;
                    console.log("res abbinamenti", res);
                    if (res.status == 200) {
                        this.servizi_suggeriti = [];
                        this.servizi_suggeriti =
                            res.data.result != null ? res.data.result : [];
                        if (this.servizi_suggeriti.length != 0) {
                            this.servizi_suggeriti.forEach((e) => {
                                e.ora_inizio_attivita = moment(
                                    e.inizio_attivita
                                ).format("HH:mm");
                                e.ora_fine_attivita = moment(
                                    e.fine_attivita
                                ).format("HH:mm");
                                e.inizio_attivita = moment(
                                    e.inizio_attivita
                                ).format("DD/MM/YYYY");

                                e.fine_attivita = moment(
                                    e.fine_attivita
                                ).format("DD/MM/YYYY");

                                e.selezionato = false;
                            });

                            this.servizi_suggeriti.sort(
                                (a, b) => a.distanza_value - b.distanza_value
                            );
                            console.log("suggeriti", this.servizi_suggeriti);
                        } else {
                            this.loading = false;
                            this.$refs.SnackbarQV.print(
                                "orange",
                                `Nessun elemento trovato.`
                            );
                        }
                    } else {
                        this.loading = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            `Nessun elemento trovato.`
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    this.loading = false;
                });
        },
        serviziSuggeritiFromPianificazione() {
            console.log(
                "servizio_pianificato_sel?",
                this.servizio_pianificato_sel,
                this.servizio_pianificato_dettaglio_sel
            );

            this.dialog_servizi_suggeriti = true;
            this.loading = true;

            const getservizi = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "abbinamentipossibili",
                    id_fascia_oraria:
                        this.servizio_associato_da_pianificare.id_fascia_oraria,
                    data_viaggi:
                        this.servizio_associato_da_pianificare.data_inizio,
                    localita_partenza:
                        this.servizio_associato_da_pianificare
                            .localita_partenza,
                    provincia_partenza:
                        this.servizio_associato_da_pianificare
                            .provincia_partenza,
                    cap_partenza:
                        this.servizio_associato_da_pianificare.cap_partenza,
                    indirizzo_partenza:
                        this.servizio_associato_da_pianificare
                            .indirizzo_partenza,
                    civico_partenza:
                        this.servizio_associato_da_pianificare.civico_partenza,
                    localita_arrivo:
                        this.servizio_associato_da_pianificare.localita_arrivo,
                    provincia_arrivo:
                        this.servizio_associato_da_pianificare.provincia_arrivo,
                    cap_arrivo:
                        this.servizio_associato_da_pianificare.cap_arrivo,
                    indirizzo_arrivo:
                        this.servizio_associato_da_pianificare.indirizzo_arrivo,
                    civico_arrivo:
                        this.servizio_associato_da_pianificare.civico_arrivo,
                    ora_inizio:
                        this.servizio_associato_da_pianificare.ora_inizio,
                    id_servizio:
                        this.servizio_pianificato_dettaglio_sel.id_servizio,
                    id_tipo_servizio_dettaglio:
                        this.servizio_pianificato_dettaglio_sel
                            .id_tipo_servizio_dettaglio,
                    id_tipo_materiale:
                        this.servizio_pianificato_dettaglio_sel
                            .id_tipo_materiale,
                    id_tipo_macchina:
                        this.servizio_pianificato_dettaglio_sel
                            .id_tipo_macchina,
                    volume: this.servizio_pianificato_dettaglio_sel.volume,
                    um_volume:
                        this.servizio_pianificato_dettaglio_sel.um_volume,
                },
            };
            this.$store
                .dispatch("api6", getservizi)
                .then((res) => {
                    this.loading = false;
                    console.log("res abbinamenti", res);

                    if (res.status == 200) {
                        this.servizi_suggeriti = [];
                        this.servizi_suggeriti =
                            res.data.result != null ? res.data.result : [];
                        if (this.servizi_suggeriti.length != 0) {
                            this.servizi_suggeriti.forEach((e) => {
                                e.ora_inizio_attivita = moment(
                                    e.inizio_attivita
                                ).format("HH:mm");
                                e.ora_fine_attivita = moment(
                                    e.fine_attivita
                                ).format("HH:mm");
                                e.inizio_attivita = moment(
                                    e.inizio_attivita
                                ).format("DD/MM/YYYY");

                                e.fine_attivita = moment(
                                    e.fine_attivita
                                ).format("DD/MM/YYYY");

                                e.selezionato = false;
                            });

                            this.servizi_suggeriti.sort(
                                (a, b) => a.distanza_value - b.distanza_value
                            );
                            console.log("suggeriti", this.servizi_suggeriti);
                        } else {
                            this.loading = false;
                            this.$refs.SnackbarQV.print(
                                "orange",
                                `Nessun elemento trovato.`
                            );
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    this.loading = false;
                });
        },
        // Aggiungi servizio
        setEliminaServiziMultipli() {
            let id_to_delete = "";
            this.servizi
                .filter((c) => c.selected == true)
                .forEach((e) => {
                    id_to_delete += e.id_servizio.toString() + ",";
                });
            id_to_delete = id_to_delete.slice(0, -1);

            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "deleteservizi",
                    token: localStorage.getItem("user_token"),
                    id_servizi: id_to_delete,
                },
            };

            // Overlay di caricamento
            this.overlay = true;

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        this.getServizi();
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Servizi eliminati correttamente."
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);

                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    // tolgo l'overlay
                    this.overlay = false;
                });

            this.delete_dialog = false;
        },

        setRipianifica(id_servizio) {
            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "ripianificaservizi",
                    token: localStorage.getItem("user_token"),
                    id_servizi: id_servizio.toString(),
                },
            };

            // Overlay di caricamento
            this.overlay = true;

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200 || res.status == 204) {
                        if (res.data.result[0].pianificazione_result == 1) {
                            this.$refs.SnackbarQV.print(
                                "success",
                                "Servizio ripianificato correttamente."
                            );
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.result[0].descrizione
                            );
                        }
                        this.getServizi();
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    // tolgo l'overlay
                    this.overlay = false;
                });

            this.ripianifica_dialog = false;
        },

        setRipianificaServiziMultipli() {
            let id_to_plan = "";
            let is_blocked = false;

            this.servizi
                .filter((c) => c.selected == true)
                .forEach((e) => {
                    if (e.des_stato != "Bloccato")
                        id_to_plan += e.id_servizio.toString() + ",";
                    else is_blocked = true;
                });
            id_to_plan = id_to_plan.slice(0, -1);

            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "ripianificaservizi",
                    token: localStorage.getItem("user_token"),
                    id_servizi: id_to_plan,
                },
            };

            // Overlay di caricamento
            this.overlay = true;
            if (id_to_plan.length > 0) {
                this.$store
                    .dispatch("api6", request)
                    .then((res) => {
                        this.overlay = false;
                        // if (res.status == 200 || res.status == 204) {
                        //   this.getServizi();
                        //   if (!is_blocked)
                        //     this.$refs.SnackbarQV.print(
                        //       "success",
                        //       "Servizi ripianificati correttamente."
                        //     );
                        //   else
                        //     this.$refs.SnackbarQV.print(
                        //       "orange",
                        //       "I servizi bloccati non sono stati pianificati."
                        //     );
                        // } else {
                        //   this.$refs.SnackbarQV.print(
                        //     "orange",
                        //     "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        //   );
                        // }
                        if (res.status == 200 || res.status == 204) {
                            if (res.data.result[0].pianificazione_result == 1) {
                                this.$refs.SnackbarQV.print(
                                    "success",
                                    "Servizio ripianificato correttamente."
                                );
                            } else {
                                this.$refs.SnackbarQV.print(
                                    "orange",
                                    res.data.result[0].descrizione
                                );
                            }
                            this.getServizi();
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Errore di comunicazione col server, non è stato possibile caricare i dati."
                            );
                        }
                    })
                    .catch((e) => {
                        console.error(e);

                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server"
                        );
                        // tolgo l'overlay
                        this.overlay = false;
                    });

                this.ripianifica_dialog = false;
            } else {
                if (is_blocked) {
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Impossibile pianificare i servizi bloccati."
                    );
                    this.overlay = false;
                    this.ripianifica_dialog = false;
                }
            }
        },

        async salvaServizio(ripianifica = false) {
            await this.getDettagliServizio();
            console.log(
                "this.selected_item - slava servizio",
                this.selected_item
            );
            if (
                this.selected_item.ora_inizio != "" &&
                this.selected_item.id_fascia_oraria != ""
            ) {
                this.selected_item.ora_inizio = "";
                this.selected_item.id_fascia_oraria = "";
                console.log("non puoi salvare", this.selected_item);
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Selezionare solo un campo tra fascia orario e ora inizio."
                );
            }

            // this.selected_item.cellulare = this.selected_item.cellulare.toString();
            if (
                this.selected_item.data_inizio == null ||
                this.selected_item.data_inizio == ""
            )
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire la data di inizio del servizio."
                );
            if (
                this.selected_item.data_fine == null ||
                this.selected_item.data_fine == ""
            )
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire la data di fine del servizio."
                );
            if (this.selected_item.id_azienda == null)
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire la ragione sociale."
                );

            // se esiste il componente di creazione dettagli
            if (this.$refs.createDettaglio) {
                if (
                    this.$refs.createDettaglio.tot_dettagli_servizio.length == 0
                ) {
                    // salvo il dettaglio
                    this.dettaglio = this.$refs.createDettaglio.selected_item;
                    this.dettaglio.id_servizio = this.selected_item.id_servizio;
                    if (
                        this.dettaglio.id_tipo_servizio_dettaglio == null ||
                        this.dettaglio.id_tipo_servizio_dettaglio == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire una descrizione servizio"
                        );
                    }

                    if (
                        this.dettaglio.id_tipo_macchina == null ||
                        this.dettaglio.id_tipo_macchina == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire un tipo veicolo"
                        );
                    }
                    if (this.dettaglio.frequenza_ripetizione_ore < 0) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Frequenza ripetizione in ore necessaria per pianificare"
                        );
                    }
                    if (
                        this.dettaglio.volume == null ||
                        this.dettaglio.volume == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire il volume"
                        );
                    }
                    if (
                        this.dettaglio.id_tipo_servizio_dettaglio != null &&
                        this.dettaglio.id_tipo_macchina != null &&
                        this.dettaglio.volume != null &&
                        this.dettaglio.frequenza_ripetizione_ore >= 0
                    ) {
                        // Se blocco fido azienda = 1 -> Stato servizio bloccato.
                        // Altrimenti stato servizio -> Aperto.
                        await this.getAziende();
                        let codice_stato =
                            this.azienda_detail.id_blocco_fido > 0 ? "B" : "A";
                        this.dettaglio.id_stato =
                            this.$refs.createDettaglio.items_stato.filter(
                                (s) => s.cod == codice_stato
                            ).length > 0
                                ? this.$refs.createDettaglio.items_stato.find(
                                      (s) => s.cod == codice_stato
                                  ).id_tabella
                                : null;

                        // se il dettaglio e stato modificato lo inserisco nell'array
                        this.dettagli_servizio.push(this.dettaglio);
                    } else
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire un opzione valida"
                        );
                }
            }

            // reimposto la tab iniziale e la data della richiesta
            this.tab = 0;
            this.selected_item.data_richiesta = moment(Date.now()).format(
                "YYYY-MM-DD"
            );
            // imposto i colori come stringa
            this.selected_item.colore_sfondo.hex
                ? (this.selected_item.colore_sfondo =
                      this.selected_item.colore_sfondo.hex)
                : "";
            this.selected_item.colore_testo.hex
                ? (this.selected_item.colore_testo =
                      this.selected_item.colore_testo.hex)
                : "";
            this.selected_item.errori = null;

            let request = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    action: "saveservizio",
                    token: localStorage.getItem("user_token"),
                    servizio: this.selected_item,
                    dettagli:
                        this.dettaglio == null
                            ? this.dettagli_servizio
                            : [this.dettaglio],
                },
            };

            // Overlay di caricamento
            this.overlay = true;
            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.overlay = false;
                    this.dettaglio = null;
                    if (res.status == 200) {
                        // aggiorno la lista di servizi e stampo una
                        // snackbar di conferma

                        this.$refs.SnackbarQV.print(
                            "success",
                            "Servizio salvato correttamente."
                        );

                        if (ripianifica)
                            this.setRipianifica(this.selected_item.id_servizio);
                        else this.getServizi();
                    } else {
                        if (
                            this.selected_item.validita === 0 &&
                            res.status === 204
                        ) {
                            this.getServizi();
                            return this.$refs.SnackbarQV.print(
                                "success",
                                "Servizio eliminato correttamente."
                            );
                        }
                        // se ci sono problemi durante il salvataggio
                        // del servizio stampa il messaggio di errore
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    // stampo l'errore
                    console.error(e);
                    // snackbar avvertimento
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server"
                    );
                    // tolgo l'overlay
                    this.overlay = false;
                });
            this.filtra();
            this.data_table = true;
            // chiudo il dialog di eliminazione
            this.delete_dialog = false;
        },

        async salvaPianificazione() {
            if (this.servizio_pianificato_sel != null) {
                this.eliminaPianificaEAssocia();
                return;
            }
            console.log("this.selected_item", this.selected_item);
            console.log(
                "this.$refs.createEdit.selected_item",
                this.$refs.createEdit.selected_item
            );
            if (
                this.selected_item.ora_inizio != "" &&
                this.selected_item.id_fascia_oraria != ""
            ) {
                this.selected_item.ora_inizio = "";
                this.selected_item.id_fascia_oraria = "";

                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Selezionare solo un campo tra fascia orario e ora inizio."
                );
            }

            this.selected_item.cellulare =
                this.selected_item.cellulare.toString();

            if (this.selected_item.id_azienda == null)
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire la ragione sociale."
                );

            if ("errori.distanza" in this.selected_item)
                if (!this.selected_item.distanza)
                    return this.$refs.SnackbarQV.print(
                        "orange",
                        this.selected_item.errori.distanza
                    );

            if ("errori.tempo_percorrenza" in this.selected_item)
                if (!this.selected_item.tempo_percorrenza)
                    return this.$refs.SnackbarQV.print(
                        "orange",
                        this.selected_item.errori.tempo_percorrenza
                    );
            if (
                !this.selected_item.localita_arrivo ||
                !this.selected_item.provincia_arrivo ||
                !this.selected_item.cap_arrivo
            )
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire tutti i dati di destinazione"
                );
            // controllo che sia stata inserita la data
            if (
                !this.selected_item.data_inizio ||
                !this.selected_item.data_fine
            )
                return this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire la data di inizio e fine del servizio."
                );

            // se il servizio e stato creato adesso eseguo il prossimo if
            if (this.dettagli_servizio.length === 0) {
                // se esiste il componente di creazione dettagli
                if (this.$refs.createDettaglio) {
                    // salvo il dettaglio
                    this.dettaglio = this.$refs.createDettaglio.selected_item;
                    this.dettaglio.id_servizio = this.selected_item.id_servizio;
                    if (
                        this.dettaglio.id_tipo_servizio_dettaglio == null ||
                        this.dettaglio.id_tipo_servizio_dettaglio == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire una descrizione servizio"
                        );
                    }
                    if (
                        this.dettaglio.id_tipo_macchina == null ||
                        this.dettaglio.id_tipo_macchina == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire un tipo veicolo"
                        );
                    }
                    if (this.dettaglio.frequenza_ripetizione_ore < 0) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Frequenza ripetizione in ore necessaria per pianificare"
                        );
                    }
                    if (
                        this.dettaglio.volume == null ||
                        this.dettaglio.volume == ""
                    ) {
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire il volume"
                        );
                    }
                    if (
                        this.dettaglio.id_tipo_servizio_dettaglio != null &&
                        this.dettaglio.id_tipo_macchina != null &&
                        this.dettaglio.volume != null &&
                        this.dettaglio.frequenza_ripetizione_ore >= 0
                    ) {
                        // Se blocco fido azienda = 1 -> Stato servizio bloccato.
                        // Altrimenti stato servizio -> Aperto.
                        await this.getAziende();
                        let codice_stato =
                            this.azienda_detail.id_blocco_fido > 0 ? "B" : "A";

                        this.dettaglio.id_stato =
                            this.$refs.createDettaglio.items_stato.filter(
                                (s) => s.cod == codice_stato
                            ).length > 0
                                ? this.$refs.createDettaglio.items_stato.find(
                                      (s) => s.cod == codice_stato
                                  ).id_tabella
                                : null;

                        console.log("1 - codice_stato?", codice_stato);

                        // se il dettaglio e stato modificato lo inserisco nell'array
                        this.dettagli_servizio.push(this.dettaglio);
                    } else
                        return this.$refs.SnackbarQV.print(
                            "orange",
                            "Inserire un opzione valida"
                        );
                } else
                    return this.$refs.SnackbarQV.print(
                        "orange",
                        "Inserire un opzione valida"
                    );
            }

            this.selected_item.errori = null;
            // reimposto la tab iniziale e la data della richiesta
            this.tab = 0;
            this.selected_item.data_richiesta = moment(Date.now()).format(
                "YYYY-MM-DD"
            );

            // imposto i colori come stringa
            this.selected_item.colore_sfondo.hex
                ? (this.selected_item.colore_sfondo =
                      this.selected_item.colore_sfondo.hex)
                : "#1976D2";
            this.selected_item.colore_testo.hex
                ? (this.selected_item.colore_testo =
                      this.selected_item.colore_testo.hex)
                : "#000000";

            // Pianifica solo i servizi dettaglio che abbiano lo stato aperto.
            let cod_stato_aperto = this.$refs.createDettaglio.items_stato.find(
                (e) => e.cod == "A"
            );
            console.log("2 - cod_stato_aperto?", cod_stato_aperto);

            let servizi_aperti = [];
            if (cod_stato_aperto)
                servizi_aperti = this.dettagli_servizio.filter(
                    (e) => e.id_stato == cod_stato_aperto.id_tabella
                );

            console.log("3 - servizi_aperti.length > 0 ?", servizi_aperti);

            if (servizi_aperti.length > 0) {
                // id dell associazione
                this.selected_item.id_servizio_associato = this.servizio_ass_sel
                    ? this.servizio_ass_sel
                    : null;
                console.log(
                    "controlla qui",
                    this.selected_item,
                    servizi_aperti
                );

                const pianificazione = {
                    controller: "logistic",
                    method: "POST",
                    richiesta: {
                        token: localStorage.getItem("user_token"),
                        action: "saveserviziopianifica",
                        servizio: this.selected_item,
                        dettagli: servizi_aperti,
                    },
                };

                this.overlay = true;
                this.data_table = true;
                this.$store.dispatch("api6", pianificazione).then((res) => {
                    this.overlay = false;
                    if (res.status === 200) {
                        if (
                            servizi_aperti.length <
                            this.dettagli_servizio.length
                        )
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Servizio salvato. I servizi non aperti non sono stati pianificati."
                            );
                        else if (
                            res.data.result[0].pianificazione_result == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "success",
                                "Servizio ripianificato correttamente."
                            );
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.result[0].descrizione
                            );
                        }
                        this.servizio_ass_sel = null;
                        if (this.servizio_pianificato_sel != null) {
                            this.eliminaServizio();
                        } else {
                            this.getServizi();
                        }
                    } else {
                        // snackbar errore
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                        setTimeout(() => {
                            this.salvaServizio();
                        }, 3000);
                    }
                });
            } else {
                this.$refs.SnackbarQV.print(
                    "error",
                    "Azienda fido bloccato: impossibile pianificare."
                );
                setTimeout(() => {
                    this.salvaServizio();
                }, 4000);
            }
            // this.filtra();
        },
        // Filtri
        filtra() {
            /* Preparo un array temporaneo in cui
             * collezionare i Servizi filtrati */
            let servizi_tmp = [];
            this.tot_servizi.forEach((v) => {
                servizi_tmp.push(v);
            });

            // Filtro per azienda
            if (
                this.azienda_filter !== "" &&
                typeof this.azienda_filter !== "object"
            ) {
                let res = [];
                servizi_tmp.forEach((elem) => {
                    if (elem.id_azienda == this.azienda_filter) {
                        res.push(elem);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }

            //Filtro per localita_partenza
            if (this.localita_partenza_filter != "") {
                let res = [];
                servizi_tmp.forEach((e) => {
                    if (
                        e.localita_partenza
                            .toUpperCase()
                            .includes(
                                this.localita_partenza_filter.toUpperCase()
                            )
                    ) {
                        res.push(e);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }
            //Filtro per localita_arrivo
            if (this.localita_arrivo_filter != "") {
                let res = [];
                servizi_tmp.forEach((e) => {
                    if (
                        e.localita_arrivo
                            .toUpperCase()
                            .includes(this.localita_arrivo_filter.toUpperCase())
                    ) {
                        res.push(e);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }
            //Filtro per descrizione
            if (this.descrizione_filter != "") {
                let res = [];
                servizi_tmp.forEach((e) => {
                    if (
                        e.descrizione
                            .toUpperCase()
                            .includes(this.descrizione_filter.toUpperCase())
                    ) {
                        res.push(e);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }
            //Filtro per codice
            if (this.codice_filter != "") {
                let res = [];
                servizi_tmp.forEach((e) => {
                    if (
                        e.codice
                            .toUpperCase()
                            .includes(this.codice_filter.toUpperCase())
                    ) {
                        res.push(e);
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(e);
                });
            }
            // Filtro per data_inizio
            if (this.data_inizio_filter != "") {
                let res = [];
                servizi_tmp.forEach((elem) => {
                    const data_formattata_filter = moment(
                        this.data_inizio_filter
                    ).format("DD/MM/YYYY");
                    const elem_data_formattata = moment(
                        elem.data_inizio
                    ).format("DD/MM/YYYY");
                    // se l'anno del servizio e maggiore o uguale va avanti
                    if (
                        elem_data_formattata.substring(8, 10) >=
                        data_formattata_filter.substring(8, 10)
                    ) {
                        // se l'anno del servizio e uguale a quello del filtro e il mese e
                        // maggiore o uguale va avanti, oppure se l'anno del servizio e maggiore va avanti
                        if (
                            (elem_data_formattata.substring(8, 10) ==
                                data_formattata_filter.substring(8, 10) &&
                                elem_data_formattata.substring(3, 5) >=
                                    data_formattata_filter.substring(3, 5)) ||
                            elem_data_formattata.substring(8, 10) >
                                data_formattata_filter.substring(8, 10)
                        ) {
                            // se il mese del servizio e maggiore a quello del filtro o il
                            // giorno e maggiore o uguale il servizio viene inserito tra quelli filtrati
                            if (
                                elem_data_formattata.substring(3, 5) >
                                    data_formattata_filter.substring(3, 5) ||
                                elem_data_formattata.substring(0, 2) >=
                                    data_formattata_filter.substring(0, 2)
                            ) {
                                res.push(Object.assign({}, elem));
                            }
                        }
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(Object.assign({}, e));
                });
            }
            // Filtro per data_fine
            if (this.data_fine_filter != "") {
                let res = [];
                servizi_tmp.forEach((elem) => {
                    const data_formattata_filter = moment(
                        this.data_fine_filter
                    ).format("DD/MM/YYYY");
                    const elem_data_formattata = moment(elem.data_fine).format(
                        "DD/MM/YYYY"
                    );
                    if (
                        elem_data_formattata.substring(8, 10) <=
                        data_formattata_filter.substring(8, 10)
                    ) {
                        if (
                            (elem_data_formattata.substring(8, 10) ==
                                data_formattata_filter.substring(8, 10) &&
                                elem_data_formattata.substring(3, 5) <=
                                    data_formattata_filter.substring(3, 5)) ||
                            elem_data_formattata.substring(8, 10) <
                                data_formattata_filter.substring(8, 10)
                        ) {
                            if (
                                elem_data_formattata.substring(3, 5) <
                                    data_formattata_filter.substring(3, 5) ||
                                elem_data_formattata.substring(0, 2) <=
                                    data_formattata_filter.substring(0, 2)
                            ) {
                                res.push(Object.assign({}, elem));
                            }
                        }
                    }
                });
                servizi_tmp = [];
                res.forEach((e) => {
                    servizi_tmp.push(Object.assign({}, e));
                });
            }
            // Ricostruisco i servizi visualizzati in base ai filtri aggiunti.
            (this.servizi = []), (this.servizi = Array.from(servizi_tmp));
        },
        // metodo che aggiorna l'id_pagamaento_default nelle opzioni dopo aver selezionato
        // l'id_azienda in generaleservizi
        aggiornaTipoPagamentoOpzioni() {
            this.id_pagamento_default =
                this.$refs.createEdit.selected_azienda.id_pagamento;

            if (this.$refs.createDettaglio) {
                this.$refs.createDettaglio.selected_item.id_pagamento =
                    this.id_pagamento_default;
            }
        },
        resetFiltri() {
            this.azienda_filter = "";
            this.localita_partenza_filter = "";
            this.localita_arrivo_filter = "";
            this.descrizione_filter = "";
            this.data_inizio_filter = "";
            this.data_fine_filter = "";
            this.servizi = [];
            this.tot_servizi.forEach((e) => {
                e.tipo_servizio =
                    e.volume != null
                        ? e.servizio +
                          " " +
                          e.volume +
                          " MQ " +
                          e.tipo_materiale
                        : e.servizio;
                this.servizi.push(e);
            });
            this.servizi.sort(
                (a, b) => new Date(a.data_inizio) - new Date(b.data_inizio)
            );
            this.servizi = this.servizi.reverse();
            // this.filtra();
        },
        goBack() {
            // torna alla home di quicklogistic
            this.$router.push("/home/quicklogistic");
        },
        getAllineaAnagrafiche() {
            const richiesta = {
                controller: "wsecogreen",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "syncanagrafiche",
                },
            };
            this.overlay = true;
            this.$store
                .dispatch("api", richiesta)
                .then((res) => {
                    this.overlay = false;
                    if (res.status == 200 || res.status == 204) {
                        let record_aggiornati = res.data.record_aggiornati
                            ? res.data.record_aggiornati
                            : 0;
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Anagrafiche allineate: " + record_aggiornati
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                    }
                })
                .catch((e) => {
                    this.$refs.SnackbarQV.print("error", "Errore: " + e);
                });
        },
        selezionaAssocia(arg) {
            this.servizi_suggeriti.forEach((e) => {
                if (arg.id_servizio == e.id_servizio) {
                    e.selezionato = !e.selezionato;
                } else {
                    e.selezionato = false;
                }
            });
            this.$forceUpdate();
        },
    },
    created() {
        this.pageChange(1);
        this.getServizi();
        this.getConfig();
        this.getItemsStato();
    },

    mounted() {
        // this.interval = setInterval(() => {
        //   this.getServizi();
        // }, 120000);
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },
};
</script>

<style scoped></style>
